'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.electronAppWake = exports.electronAppSleep = exports.autoUpdateError = exports.autoUpdateForcePoll = exports.autoUpdateCheckComplete = exports.autoUpdateCheckForUpdates = exports.autoUpdateInstallUpdate = exports.autoUpdateComplete = exports.autoUpdateAvailable = undefined;

var _electronConstants = require('./electronConstants');

var autoUpdateAvailable = exports.autoUpdateAvailable = function autoUpdateAvailable() {
    return {
        type: _electronConstants.AUTOUPDATE_DOWNLOAD_START
    };
};

var autoUpdateComplete = exports.autoUpdateComplete = function autoUpdateComplete(_ref) {
    var name = _ref.name,
        date = _ref.date,
        notes = _ref.notes,
        url = _ref.url;
    return {
        name: name,
        date: date,
        notes: notes,
        url: url,
        type: _electronConstants.AUTOUPDATE_DOWNLOAD_COMPLETE
    };
};

var autoUpdateInstallUpdate = exports.autoUpdateInstallUpdate = function autoUpdateInstallUpdate() {
    return {
        type: _electronConstants.AUTOUPDATE_UPDATE_INSTALL
    };
};

var autoUpdateCheckForUpdates = exports.autoUpdateCheckForUpdates = function autoUpdateCheckForUpdates() {
    return {
        type: _electronConstants.AUTOUPDATE_CHECK_START
    };
};

var autoUpdateCheckComplete = exports.autoUpdateCheckComplete = function autoUpdateCheckComplete() {
    return {
        type: _electronConstants.AUTOUPDATE_CHECK_COMPLETE
    };
};

var autoUpdateForcePoll = exports.autoUpdateForcePoll = function autoUpdateForcePoll() {
    return {
        type: _electronConstants.AUTOUPDATE_FORCE_POLL
    };
};

var autoUpdateError = exports.autoUpdateError = function autoUpdateError(_ref2) {
    var error = _ref2.error;
    return {
        type: _electronConstants.AUTOUPDATE_ERROR,
        error: error
    };
};

var electronAppSleep = exports.electronAppSleep = function electronAppSleep() {
    return {
        type: _electronConstants.ELECTRON_APP_SLEEP
    };
};

var electronAppWake = exports.electronAppWake = function electronAppWake() {
    return {
        type: _electronConstants.ELECTRON_APP_WAKE
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/electron/electronActions.js
// module id = 2263
// module chunks = 0